import React from "react";

const SpO2 = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_1632_216" x="0" y="0" width="25" height="25">
        <rect width="25" height="25" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1632_216)">
        <path
          d="M12.6043 20.7288C12.3439 20.7288 12.1226 20.6377 11.9403 20.4554C11.758 20.2731 11.6668 20.0518 11.6668 19.7913V15.6247C11.6668 15.3643 11.758 15.1429 11.9403 14.9606C12.1226 14.7783 12.3439 14.6872 12.6043 14.6872H15.2085C15.4689 14.6872 15.6903 14.7783 15.8726 14.9606C16.0549 15.1429 16.146 15.3643 16.146 15.6247V19.7913C16.146 20.0518 16.0549 20.2731 15.8726 20.4554C15.6903 20.6377 15.4689 20.7288 15.2085 20.7288H12.6043ZM13.021 19.3747H14.7918V16.0413H13.021V19.3747ZM17.7085 22.9163V20.0518C17.7085 19.7798 17.7968 19.5555 17.9733 19.379C18.1498 19.2025 18.374 19.1143 18.646 19.1143H21.0418V18.0205H17.7085V16.6663H21.4585C21.7305 16.6663 21.9547 16.7546 22.1312 16.9311C22.3077 17.1076 22.396 17.3318 22.396 17.6038V19.5309C22.396 19.8029 22.3077 20.0272 22.1312 20.2037C21.9547 20.3802 21.7305 20.4684 21.4585 20.4684H19.0627V21.5622H22.396V22.9163H17.7085ZM9.7224 22.8816C7.49438 22.708 5.66423 21.8212 4.23193 20.221C2.79964 18.6209 2.0835 16.6721 2.0835 14.3747C2.0835 12.6386 2.7736 10.7505 4.15381 8.71061C5.53402 6.67068 7.62169 4.46148 10.4168 2.08301C12.7316 4.0506 14.5791 5.93717 15.9594 7.74272C17.3396 9.5483 18.2062 11.215 18.5592 12.7427H11.4585C10.9782 12.7427 10.5687 12.912 10.2302 13.2505C9.89167 13.5891 9.7224 13.9985 9.7224 14.4788V22.8816Z"
          fill="#F2994A"
        />
      </g>
    </svg>
  );
};

export default SpO2;
